import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-container',
  templateUrl : './auth-container.component.html',
  styleUrls: ['./auth-container.component.scss']
})
export class AuthContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


  
  ngAfterViewInit(): void{
    //this.document.body.classList.remove('dark-theme');
        // Get elements with class 'dark-theme'
    var darkThemeElements = document.body.getElementsByClassName('dark-theme');

    // Iterate through each element and remove the 'dark-theme' class
    for (var i = 0; i < darkThemeElements.length; i++) {
      darkThemeElements[i].classList.remove('dark-theme');
}
  }

}
